import * as types from "../actions/actionTypes";
import initialState from "./initialState";
const notificationPrefix = "Notifications.";

export default function notificationReducer(state = initialState.notifications, action) {
  switch (action.type) {
    case types.LOAD_NOTIFICATIONS_SUCCESS: {
      const { notifications, unread } = action.payload;
      const lastNotifications =
        notifications &&
        notifications.values.map(item => {
          return {
            ...item,
            isPersistent: true,
            translatable: item.deliveryMethod === "None" ? true : false
          };
        });
      const newData =
        notifications && (notifications.page === 1 ? lastNotifications : [...state.data, ...lastNotifications]);
      const notPersisted = state.data.filter(n => !n.isPersistent && !n.isRead);

      return {
        ...state,
        unreadNotifications: unread + notPersisted.length,
        totalNotifications: notifications && notifications.totalCount,
        data: Object.assign([], newData, { isLoaded: true })
      };
    }

    case types.NOTIFICATION_SENT:
      return {
        ...state,
        unreadNotifications: state.unreadNotifications + 1,
        totalNotifications: state.totalNotifications + 1,
        data: [
          {
            notificationId: action.event.eventBody.notificationId,
            notificationTitle: action.event.eventBody.notificationTitle,
            notificationBody: action.event.eventBody.notificationBody,
            sourceContextKeys: action.event.eventBody.sourceContextKeys,
            sourceContextName: action.event.eventBody.sourceContextName,
            isPersistent: true,
            translatable: action.event.eventBody.deliveryMethod === "None" ? true : false,
            isRead: false
          },
          ...state.data
        ]
      };

    case types.ADD_NOTIFICATION:
      return {
        ...state,
        unreadNotifications: state.unreadNotifications + 1,
        totalNotifications: state.totalNotifications + 1,
        data: [
          {
            notificationId: state.data.length + 1,
            notificationTitle: `${notificationPrefix}${action.payload.notificationType}`,
            notificationType: action.payload.notificationType,
            notificationBody: action.payload.notificationBody,
            isRead: false,
            translatable: true
          },
          ...state.data
        ]
      };

    case types.NOTIFICATION_MARKED_AS_READ: {
      let found = false;
      let updatedNotification = state.data.map(notification => {
        if (notification.notificationId === action.event.eventBody.notificationId && !notification.isRead) {
          found = true;
          return { ...notification, isRead: true };
        }
        return notification;
      });

      return {
        ...state,
        unreadNotifications: found ? state.unreadNotifications - 1 : state.unreadNotifications,
        data: updatedNotification
      };
    }

    case types.ALL_NOTIFICATIONS_MARKED_AS_READ: {
      return {
        ...state,
        unreadNotifications: 0,
        data: state.data.map(notification => ({ ...notification, isRead: true }))
      };
    }

    case types.ALL_FRONTEND_NOTIFICATIONS_DISMISSED: {
      return {
        ...state,
        unreadNotifications: 0,
        data: Object.assign([], { isLoaded: true })
      };
    }

    case types.NOTIFICATION_DISMISSED: {
      const list = state.data.filter(n => n.notificationId !== action.event.eventBody.notificationId);

      return {
        ...state,
        unreadNotifications: list.filter(item => !item.isRead).length,
        data: list
      };
    }

    case types.SIGNAL_R_EVENT_RECEIVED: {
      let filtered = state.data.filter(notification => notification.sourceId !== action.event.correlationId);
      return {
        ...state,
        unreadNotifications: state.unreadNotifications - (state.data.length - filtered.length),
        data: filtered
      };
    }

    case types.BEGIN_ASYNC_COMMAND:
      return {
        ...state,
        unreadNotifications: state.unreadNotifications + 1,
        data: [
          {
            notificationId: state.data.length + 1,
            notificationType: action.payload.commandType,
            notificationTitle: `${notificationPrefix}${action.payload.commandType}`,
            notificationBody: action.payload.commandData,
            sourceId: action.payload.correlationId,
            translatable: true
          },
          ...state.data
        ]
      };

    case types.END_ASYNC_COMMAND: {
      let filtered = state.data.filter(notification => notification.sourceId !== action.payload.correlationId);
      return {
        ...state,
        unreadNotifications: state.unreadNotifications - (state.data.length - filtered.length),
        data: filtered
      };
    }

    default:
      return state;
  }
}
